import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import InventoryService from '../services/InventoryService';
import { isEmpty } from 'lodash';

const initialState = {
  data: [],
  datas: [],
  summary: {},
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
  isOpenInventoryDialog: false,

  openingStockLoading: false,
  openingStockSuccess: false,
  openingStockError: []
};

export const InventoryAll = createAsyncThunk(
  'inventory/all',
  async ({ perPage, page, keyword, type, warehouse_id, category_id, is_low_stock, below_cost, not_orderable }) => {
    try {
      const resp = await InventoryService.All({ perPage, page, keyword, type, warehouse_id, category_id, is_low_stock, below_cost, not_orderable });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const InventoryTransactionAction = createAsyncThunk('inventory/transaction', async (data) => {
  try {
    const response = await InventoryService.Transaction(data);
    // if(response?.status === 200 ) {
    //   navigate('/inventory-transactions');
    // }
    return response;
  } catch (error) {
    return error.response;
  }
}
)

export const importOpeningStock = createAsyncThunk(
  'openingStock/importOpeningStock',
  async (payload, { rejectWithValue }) => {
    try {
      const resp = await InventoryService.ImportOpeningStock(payload);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

const inventoryAction = createSlice({
  name: 'inventory',
  initialState: initialState,
  reducers: {
    openInventoryDialog: (state, action) => {
      state.isOpenInventoryDialog = action.payload;
    },
    openingStockStateReset: (state) => {
      state.openingStockLoading = false;
      state.openingStockSuccess = false;
      state.openingStockError = [];
      state.formError = [];
    },
    updateInventoryOrderFlag: (state, action) => {
      const { id, is_order } = action.payload;
      const index = state.datas.findIndex((row) => row.id === id);
      if (index === -1) return;

      const previous = !!state.datas[index].is_order;
      const next = !!is_order;
      if (previous === next) return;

      state.datas[index] = {
        ...state.datas[index],
        is_order: next,
      };

      const currentCount = state.summary?.not_orderable_count ?? 0;
      state.summary = {
        ...state.summary,
        not_orderable_count: next
          ? Math.max(0, currentCount - 1)
          : currentCount + 1,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(InventoryAll.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(InventoryAll.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.inventoryList];
          state.pagination = action.payload?.data?.data?.pagination;
          state.summary = action.payload?.data?.data?.summary;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(InventoryAll.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(InventoryTransactionAction.pending, (state, action) => {
        state.loading = true
      })
      .addCase(InventoryTransactionAction.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          toast.success(action.payload?.data?.message);
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(InventoryTransactionAction.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(importOpeningStock.pending, (state, action) => {
        state.openingStockLoading = true;
        state.openingStockSuccess = false;
      })
      .addCase(importOpeningStock.fulfilled, (state, action) => {
        toast.success(action.payload?.data.message);
        state.openingStockLoading = false;
        state.openingStockSuccess = true;
      })
      .addCase(importOpeningStock.rejected, (state, action) => {
        state.openingStockLoading = false;
        const errors = action.payload?.data?.data?.errors;
        state.openingStockSuccess = false;

        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.openingStockError = errors;
        }
      });
  },
});

const { reducer } = inventoryAction;

export const { openInventoryDialog, openingStockStateReset, updateInventoryOrderFlag } = inventoryAction.actions;

export const inventorySelector = (state) => state?.inventory;

export default reducer;